<template>
  <div class="rounded bordered bg-white q-pa-md text-center">
    <h6>Contact FleetPartners for more information</h6>
    <p><a href="tel:1300 666 001">1300 666 001</a></p>
    <p>
      <a href="mailto:info@fleetpartners.com.au">info@fleetpartners.com.au</a>
    </p>
    <p>
      <a href="https://www.fleetpartners.com.au" target="_blank">www.fleetpartners.com.au</a>
    </p>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
export default {
  name: 'ContactUs'
};
</script>

<style lang="sass" scoped>
h6
  color: #0A2644;
  font-weight: 500;
  margin-bottom: 5px;
p
  margin-bottom: 0;
  padding-bottom: 5px;
a
  color: $primary;
</style>
